import axiosServices from 'utils/axios';
import { GenericTableConfigDto, GenericTableConfigPatchDto } from './dto';
import { InsideFifaBackOfficeEndpoints } from '../consts';
import omit from 'lodash/omit';

export class ConfigUpdateConflictError extends Error {}
export class ConfigUpdateColumnsConflictError extends ConfigUpdateConflictError {}

export const updateConfig = async (
    configId: number,
    configPatch: GenericTableConfigPatchDto,
): Promise<GenericTableConfigDto> => {
    const patchBody = omit(configPatch, 'force');
    const force = 'force' in configPatch && Boolean(configPatch.force);

    try {
        const res = await axiosServices.patch(
            `${InsideFifaBackOfficeEndpoints.GenericTables.Configs}/${configId}${force ? '?force=true' : ''}`,
            patchBody,
        );

        return res.data;
    } catch (error) {
        if (error && typeof error === 'object' && 'status' in error && error.status === 409) {
            const isColumnsConflictError =
                'data' in error &&
                typeof error.data === 'object' &&
                error.data &&
                'message' in error.data &&
                typeof error.data?.message === 'string' &&
                error.data.message.startsWith('Columns');

            throw isColumnsConflictError ? new ConfigUpdateColumnsConflictError() : new ConfigUpdateConflictError();
        }

        throw error;
    }
};
